var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { SALogoNoBrandingLogoBugWhite, SALogoNoBrandingLogoWhite, SALogoStateAutoLogoBugWhite, SALogoStateAutoLogoWhite, } from './logos';
// TODO: Figure out how to cleanly type this (remove any type).
var LogoMap = {
    noBrandingLogoBugWhite: SALogoNoBrandingLogoBugWhite,
    noBrandingLogoWhite: SALogoNoBrandingLogoWhite,
    stateAutoLogoBugWhite: SALogoStateAutoLogoBugWhite,
    stateAutoLogoWhite: SALogoStateAutoLogoWhite,
};
export function SALogo(props) {
    // eslint-disable-next-line react/destructuring-assignment
    var LogoComponent = props.name ? LogoMap[props.name] : LogoMap.stateAutoLogoWhite;
    // eslint-disable-next-line react/jsx-props-no-spreading
    return React.createElement(LogoComponent, __assign({}, props));
}
//# sourceMappingURL=logo.component.js.map